/** @jsx jsx */
import {jsx} from "theme-ui"
import Layout from "../layout"
import Paragraph from "../paragraph"
import SectionHeading from "../SectionHeading"
import SliderContainer from "./Slider/SliderContainer"
import Quote from "../../icons/quote.svg"
import Ornament2 from "../Ornaments/Ornament2"
import Sign from "../../icons/ourstory-sign.svg"
import { useBreakpointIndex } from '@theme-ui/match-media'
import { alpha } from "@theme-ui/color"

const TestimonialData = [
  {
    by: 'John Doe',
    position: 'CEO at Company',
    content: 'We were at The Chinese Restaurant a few weeks ago with some clients from Texas. I am finally getting back to tell you that we had a wonderful evening! The food, the service, the host, EVERYTHING was perfect! Thank you again for making TFG such a special place to be. We hope to see you again soon!'
  },
  {
    by: 'Lizie Black',
    position: 'Ordinary Muggle',
    content: 'We were at The Chinese Restaurant a few weeks ago with some clients from Texas. I am finally getting back to tell you that we had a wonderful evening! The food, the service, the host, EVERYTHING was perfect!'
  },
  {
    by: 'John Doe',
    position: 'CEO at Company',
    content: 'We were at The Chinese Restaurant a few weeks ago with some clients from Texas. I am finally getting back to tell you that we had a wonderful evening! The food, the service, the host, EVERYTHING was perfect! Thank you again for making TFG such a special place to be. We hope to see you again soon!'
  },
  {
    by: 'Lizie Black',
    position: 'Ordinary Muggle',
    content: 'We were at The Chinese Restaurant a few weeks ago with some clients from Texas. I am finally getting back to tell you that we had a wonderful evening! The food, the service, the host, EVERYTHING was perfect!'
  }
]

const Testimonial = (props) => (
  <div sx={{
    boxSizing: 'border-box',
    px: 4,
  }}>
    <div sx={{
      my: 5,
      px: 6,
      pb: 7,
      bg: 'white',
      borderRadius: 2,
      boxShadow: 'small'
    }}>
      <Quote sx={{
        position: 'relative',
        top: '-1rem',
        fill: 'secondaryColor'
      }} />
      <Paragraph>{props.children}</Paragraph>
      <span><strong sx={{color: 'neutral600', mr: 2}}>{props.by}</strong> {props.position}</span>
    </div>
  </div>
)

export default function Testimonials(props) {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1010,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };
  const breakpointIndex = useBreakpointIndex();
  return (
    <Layout>
      <div sx={{
          py: [5, 5, 5],
          my: [5, 12, 12],
          position: 'relative'
        }} id={props.id}>
        <div sx={{textAlign: 'center'}}><SectionHeading caption="What our customers say">Testimonials</SectionHeading></div>
          <SliderContainer settings={settings}>
            {TestimonialData.map((item, index) => (
              <Testimonial by={item.by} position={item.position} key={index}>{item.content}</Testimonial>
            ))}
          </SliderContainer>
          {props.hasOrnaments ? (
            breakpointIndex >= 1 ? (
              <div>
                <div sx={{
                  width: '100%',
                  position: 'absolute',
                  bottom: '-1rem',
                  left: '-16rem',
                  zIndex: -1
                }}><Sign sx={{fill: alpha('neutral600', 0.2)}} /></div>
                  <div sx={{width: '40%',
                  position: 'absolute',
                  bottom: '-12rem',
                  right: '-14rem',
                  zIndex: 3}}><Ornament2 /></div>
              </div>
            ) : ( null )
          ) : ( null )}
      </div>
    </Layout>
  );
  }